import React, { useEffect, useState } from "react";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getSession } from "../../../../redux/actions/authActions";
import {
  addToCart,
  getCartItems,
  updateCart,
} from "../../../../redux/actions/dbactions/cartActions";
import { getProfileSession } from "../../../../redux/actions/dbactions/profileActions";
import { refTypesList } from "../../../../redux/actions/dbactions/refactions";
import { serviceList } from "../../../../redux/actions/dbactions/ServicesActions";
import { Header } from "../../../Header";
import { NewCalender } from "../NewCalender";
import { ServiceCard } from "./ServiceCard";
import { useLocation } from "react-router-dom";

export const ServicesOpen = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const patient = params.get("patient");
  const { facilityId } = useParams();
  const { role_id } = getSession();
  const dispatch = useDispatch();
  const [calendar, setCalendar] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  const [shipInstructions, setShipInstructions] = useState({});

  const { exploreList } = useSelector((state) => state.exploreReducer);
  const exploreService = exploreList?.svc_typ_desc;
  const explorelist = exploreList.usr?.rec || [];
  const cartItems = useSelector((state) => state?.cart?.cartItems);

  const { service } = useSelector((state) => state.serviceList);

  const servicesMap = service?.usr?.rec;

  useEffect(() => {
    dispatch(serviceList(facilityId));
  }, [facilityId, dispatch]);

  useEffect(() => {
    dispatch(refTypesList());
  }, [facilityId, dispatch]);

  useEffect(() => {
    if (localStorage?.getItem("timeSlots")) {
      const slots = JSON.parse(localStorage.getItem("timeSlots"));
      setCalendar(slots);
    }
  }, []);

  const { bookingData } = useSelector((state) => state.patientlist);

  const { user_profile_id } = getSession();

  const { profileData } = getProfileSession();

  const handleCartData = (item) => {
    const specificInstruction = shipInstructions[item.svc_id] || "";

    const newItem = {
      svc_id: item.svc_id,
      svc_name: item.svc_name,
      svc_qnty_nbr: 1,
      svc_status_id: 1,
      svc_price_amt: item.svc_cost_amt || 0,
      svcfee_id: 1,
      sys_user_id: user_profile_id,
      sys_ordl_active_yn: "Y",
      sys_crte_tsp: profileData?.sys_crte_tsp || new Date().toISOString(),
      sys_last_updte_tsp:
        profileData?.sys_updte_tsp || new Date().toISOString(),
      order_ship_instructions: specificInstruction || "",
      ord_svc_date: bookingData?.ord_svc_date,
      ord_svc_time: bookingData?.ord_svc_time,
      svcf_id: item.svc_svcf_id,
    };

    const existingCartData =
      (cartItems[0]?.svcsc_cart_jsn?.service_order_line || []) ?? [];

    return [...existingCartData, newItem];
  };

  const handleCalenderOpen = (svcf_id, item) => {
    setOpen(true);
    setSelectedID(svcf_id);
    setSelectedService(item);
  };

  const handleDone = (value) => {
    const updatedCartData = value;
    const data = {
      user_profile_id,
      sys_active_yn: "Y",
      sys_user_id: user_profile_id,
      svcsc_cart_jsn: {
        ord_svc_date: bookingData?.ord_svc_date,
        ord_svc_time: bookingData?.ord_svc_time,
        order_dte_tsp: new Date().toISOString(),
        order_svcf_id: selectedService?.svc_svcf_id,
        user_profile_id: user_profile_id,
        order_svc_user_id: orderPatient?.svcuser_profile_id, // if patient is selected first
        order_ship_to_id: 2,
        order_ship_instructions: "Ring the bell upon arrival",
        order_bill_to_id: 2,
        order_status_id: 1,
        sys_user_id: user_profile_id,
        role_id: profileData?.role_id,
        sys_source_ip: "192.168.2.2",
        sys_crte_tsp: profileData?.sys_crte_tsp,
        sys_last_updte_tsp: profileData?.sys_updte_tsp,
        sys_ord_active_yn: "Y",
        service_order_line: updatedCartData,
      },
    };

    if (cartItems?.length > 0) {
      dispatch(updateCart(data)).then(() => {
        dispatch(getCartItems());
        setShipInstructions("");
      });
    } else {
      dispatch(addToCart(data)).then(() => {
        dispatch(getCartItems());
        setShipInstructions("");
      });
    }
  };

  const handleChangeSplInstructions = (id, value) => {
    setShipInstructions((prevValues) => ({ ...prevValues, [id]: value }));
  };
  let orderPatient = JSON.parse(localStorage.getItem("newPatient"));
  return (
    <div>
      <Header
        pageTitle={`Explore > ${exploreService} > ${
          explorelist?.at(0)?.svcf_name
        } > Services List`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-wrap m-0">
          {orderPatient?.svcuser_profile_id
            ? `Services for ${orderPatient.user_first_name}`
            : "Explore Service List"}
        </h5>
        <div className="w-fit whitespace-nowrap">
          {role_id === "4" ? (
            ""
          ) : (
            <div className="flex items-center gap-2">
              <button
                onClick={() =>
                  history.push(
                    `/dashboard/explore/${facilityId}/patient-profiles`
                  )
                }
                className="sign_btn !text-xs !flex gap-1 !items-center"
                disabled={
                  !cartItems?.length ||
                  patient ||
                  orderPatient?.svcuser_profile_id
                }
              >
                Add Patient
              </button>
            </div>
          )}
        </div>
      </div>
      <Row className="sm:!px-4 m-0">
        {servicesMap?.length > 0 ? (
          servicesMap?.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <ServiceCard
                data={item}
                selectedColor={null}
                isDisabled={null}
                dispatch={dispatch}
                facilityId={facilityId}
                user_profile_id={user_profile_id}
                handleCalenderOpen={() =>
                  handleCalenderOpen(item.svcf_id, item)
                }
                shipInstructions={shipInstructions}
                setShipInstructions={setShipInstructions}
                handleChangeSplInstructions={handleChangeSplInstructions}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Services found</p>
          </Col>
        )}

        <NewCalender
          selectedID={selectedID}
          show={open}
          onHide={() => setOpen(false)}
          dispatch={dispatch}
          calendar={calendar}
          handleDone={handleDone}
          handleCartData={() => handleCartData(selectedService)}
          cartData={[]}
        />
      </Row>
    </div>
  );
};
